import { Button } from '@imprivata-cloud/components';
import { Button as LinkButton } from '@imprivata-cloud/design-system';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { NonPurchasedProduct } from '../../../../api/types';
import HexPattern from '../../../../assets/product_card_pattern.svg?react';
import { useStartTrial } from '../../../hooks/useLandingPage';
import './UnpurchasedProductCard.less';

type UnpurchasedProductCardProps = { product: NonPurchasedProduct; canStartTrial: boolean };

export const UnpurchasedProductCard = ({ product, canStartTrial }: UnpurchasedProductCardProps) => {
  const { t } = useTranslation();
  const { mutate, isPending } = useStartTrial();

  return (
    <div className={`marketing-card ${product.productTag}`}>
      <HexPattern className={'marketing-pattern'} aria-hidden />
      <h3 className={'marketing-title'}>{product.displayName}</h3>
      <div className={'marketing-actions'}>
        {canStartTrial && (
          <Button
            className={'start-trial'}
            label={t('portal.landing.trial.start')}
            loading={isPending}
            disabled={isPending}
            aria-busy={isPending}
            onClick={() => mutate()}
          />
        )}
        <LinkButton
          variant="link"
          iconLeft={<ExternalLink aria-hidden="true" />}
          className={'marketing-link'}
          href={product.learnMoreUrl}
          target={'_blank'}
          rel={'noopener noreferrer'}
        >
          {t('portal.landing.learn-more')}
        </LinkButton>
      </div>
    </div>
  );
};
